<template>
  <div :class="isWidget ? 'tool-widget' : 'tool-page'">
    <div class="tool-content">
      <div v-if="!isWidget" class="tool-heading">
        <div>
          <h2>视频去重 V2</h2>
          <p>上传视频并选择二创特效，快速生成去重视频</p>
        </div>
        <app-icon  class="app-icon" name="auto_fix_high"></app-icon>
      </div>

      <div class="tool-card">
        <section class="section-block">
          <div class="section-header upload-header">
            <div class="section-title">上传视频</div>
            <el-button v-if="!isWidget" type="text" size="small" class="record-button" @click="$router.push('/user2/record')">
              <i class="el-icon-time"></i> 制作记录
            </el-button>
          </div>
          <qhyuploadv2 ref="qhyupload"></qhyuploadv2>
        </section>

        <template v-if="modesLoading">
          <section class="section-block">
            <div class="section-title">预设方案</div>
            <div class="chip-row skeleton-row">
              <span v-for="n in 4" :key="'y' + n" class="skeleton-chip"></span>
            </div>
          </section>
          <section class="section-block">
            <div class="section-title">二创特效</div>
            <div class="chip-row skeleton-row">
              <span v-for="n in 8" :key="'m' + n" class="skeleton-chip"></span>
            </div>
          </section>
        </template>

        <section class="section-block">
          <div class="section-header">
            <div class="section-title">预设方案</div>
            <div class="section-actions">
              <span @click="yushe_edit_id = yushe_edit_id == null ? true : null">
                {{ yushe_edit_id == null ? '编辑' : '取消编辑' }}
              </span>
              <span @click="yushe_save"><i class="el-icon-document-add"></i> 保存选择</span>
            </div>
          </div>
          <div class="chip-row">
            <button v-for="(item, index) in yushe" :key="index" type="button" class="chip preset-chip"
              :class="{ active: index === yushe_index }"
              @click="selectPreset(index, item)">
              <span>{{ item.name }}</span>
              <i v-if="yushe_edit_id !== null && isUserPreset(index)"
                class="el-icon-edit-outline preset-edit-icon" title="编辑方案"
                @click.stop="editPreset(index)"></i>
              <i v-if="yushe_edit_id !== null && isUserPreset(index)"
                class="el-icon-close preset-delete-badge" title="删除方案"
                @click.stop="deletePreset(index)"></i>
            </button>
          </div>
        </section>

        <section class="section-block">
          <div class="section-title">二创特效</div>
          <div class="chip-row">
            <button v-for="(item, index) in (ms_list.data || [])"
              :key="item.value != null ? item.value : index" type="button" class="chip"
              :class="{ active: ms_check.includes(ms_mode_key(item)) }" @click="ms_check_fc(ms_mode_key(item))">
              {{ item.name }}
            </button>
          </div>
        </section>

        <el-button class="submit-btn" type="primary" :loading="uploading" @click="ks">立即制作</el-button>
      </div>
    </div>

    <el-dialog title="编辑方案" :visible="typeof yushe_edit_id === 'number'" custom-class="newdialog">
      <div v-if="typeof yushe_edit_id === 'number'" class="dialog-input">
        <span>名称：</span>
        <el-input v-model="yushe[yushe_edit_id].name" placeholder="请输入名称" size="medium"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="danger" @click="yushe_edit('删除', yushe_edit_id)">删除</el-button>
        <el-button size="medium" type="primary" @click="yushe_edit('重命名', yushe_edit_id)">确定</el-button>
        <el-button size="medium" @click="yushe_edit_id = true">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LegacyQcai from '../User/Qcai.vue'
import qhyuploadv2 from '@/components/common/qhyuploadv2.vue'

export default {
  name: 'User2Qcai',
  extends: LegacyQcai,
  components: { qhyuploadv2 },
  props: { limit: { type: Number, default: 0 } },
  data() {
    return {
      modesLoading: true,
      officialPresetCount: 0
    }
  },
  computed: {
    isWidget() { return this.limit > 0 }
  },
  methods: {
    // 2.0 模式改从新后端加载（老逻辑调 /qhy/user/ms_v2）
    get_ms() {
      this.modesLoading = true
      this.$ajax.post('api/v1/tasks/ms_v2', {}).then(res => {
        if (res.data && res.data.status === 200) {
          this.ms_list = res.data
          const rows = this.ms_list.data || []
          if (rows.length) {
            const first = rows[0]
            this.ms_check = [first.value != null ? first.value : first.url]
          } else {
            this.ms_check = []
          }
          this.ms_other = res.data.other || []
          this.yushe = Array.isArray(res.data.yushe) ? res.data.yushe : []
          this.officialPresetCount = this.yushe.length
          this.yushe_get()
          try {
            const ui = window.sessionStorage.getItem('userinfo')
            if (ui && JSON.parse(ui).fwq) this.url_num = 200
          } catch (error) { /* ignore */ }
        } else {
          this.$msg.error((res.data && res.data.msg) || '异常')
        }
      }).catch(() => {
        this.$msg.error('模式加载失败，请稍后重试')
      }).finally(() => {
        this.modesLoading = false
      })
    },
    isUserPreset(index) {
      return index >= this.officialPresetCount
    },
    selectPreset(index, item) {
      this.yushe_index = index
      this.ms_check = Array.isArray(item.list) ? [...item.list] : []
    },
    editPreset(index) {
      if (!this.isUserPreset(index)) return
      this.yushe_edit_id = index
    },
    deletePreset(index) {
      if (!this.isUserPreset(index)) return
      this.yushe_edit('删除', index)
    }
  }
}
</script>

<style scoped>
.tool-page { min-height: 100%; padding: 24px 24px 48px; background: #f5f7fa; box-sizing: border-box; }
.tool-widget { box-sizing: border-box; }
.tool-widget .tool-card { padding: 0 0 24px; border: 0; box-shadow: none; }
.tool-widget .section-block:first-child .section-title { display: none; }
.tool-content { max-width: 1080px; margin: 0 auto; }
.tool-page .tool-content { padding-bottom: 48px; }
.tool-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.tool-heading h2 { margin: 0 0 6px; color: #1e293b; font-size: 22px; }
.tool-heading p { margin: 0; color: #94a3b8; font-size: 13px; }
.tool-heading > span { padding: 11px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; font-size: 28px; }
.tool-card { padding: 24px 24px 48px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15, 23, 42, .04); }
.section-block + .section-block { margin-top: 26px; }
.section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.section-header.upload-header { margin-bottom: 15px; }
.section-title { margin-bottom: 12px; color: #1e293b; font-size: 14px; font-weight: 600; }
.section-header .section-title { margin-bottom: 0; }
.record-button { padding: 0; }
.section-actions { display: flex; gap: 16px; color: #1a73e8; font-size: 12px; cursor: pointer; }
.chip-row { display: flex; flex-wrap: wrap; gap: 8px; }
.chip { min-width: 76px; padding: 8px 15px; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc; color: #64748b; cursor: pointer; transition: .2s; }
.preset-chip { position: relative; }
.preset-edit-icon { margin-left: 8px; color: #1a73e8; font-size: 13px; }
.chip.active .preset-edit-icon { color: #fff; }
.preset-delete-badge {
  position: absolute;
  top: -7px;
  right: -7px;
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f56c6c;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(245, 108, 108, .35);
}
.chip:hover { border-color: #93c5fd; color: #1a73e8; }
.chip.active { border-color: #1a73e8; background: #1a73e8; color: #fff; }
.submit-btn { width: 100%; margin-top: 30px; border-color: #1a73e8; background: #1a73e8; }
.dialog-input { display: flex; align-items: center; gap: 8px; }
.dialog-input .el-input { flex: 1; }
/* 模式加载骨架 */
.skeleton-row { display: flex; flex-wrap: wrap; gap: 8px; }
.skeleton-chip {
  width: 76px;
  height: 34px;
  border-radius: 8px;
  background: linear-gradient(90deg, #eef1f5 25%, #f8fafc 50%, #eef1f5 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s infinite;
}
@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@media (max-width: 768px) { .tool-page { padding: 14px 14px 32px; } .tool-card { padding: 16px 16px 32px; } .tool-page .tool-content { padding-bottom: 32px; } }
</style>



// WEBPACK FOOTER //
// src/components/User2/Qcai.vue